import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';

import React from 'react';
import ReactDOM from 'react-dom';
import {Provider} from 'react-redux';
import ReactPinterestTag from "react-pinterest-tag";
import ReactGA from 'react-ga'
import * as serviceWorker from './serviceWorker';
import FontFaceObserver from 'fontfaceobserver';
import {applyRouterMiddleware, browserHistory, Router} from 'react-router';
import {syncHistoryWithStore} from 'react-router-redux';
import {useScroll} from 'react-router-scroll';
import LanguageProvider from './containers/LanguageProvider';
import configureStore from './store';
import {hideLoading, showLoading} from 'react-redux-loading-bar';
import Raven from 'raven-js';
import App from './containers/App';
import createRoutes from './routes';
import 'sanitize.css/sanitize.css';
import './styles/styles.scss';
// Observe loading of Open Sans (to remove open sans, remove the <link> tag in
// the index.html file and this observer)
const openSansObserver = new FontFaceObserver('Open Sans', {});

// When Open Sans is loaded, add a font-family using Open Sans to the body
openSansObserver.load().then(
    () => {
        document.body.className = 'font-loaded';
    },
    () => {
        document.body.className = '';
    }
);

// Create redux store with history
// this uses the singleton browserHistory provided by react-router
// Optionally, this could be changed to leverage a created history
// e.g. `const browserHistory = useRouterHistory(createBrowserHistory)();`
const initialState = {};
const store = configureStore(initialState, browserHistory);

// Sync history and store, as the react-router-redux reducer
// is under the non-default key ("routing"), selectLocationState
// must be provided for resolving how to retrieve the "route" in the state

const history = syncHistoryWithStore(browserHistory, store);

const rootRoute = {
    component: App,
    childRoutes: createRoutes(store)
};


//initialize Raven sentry.io error logging
const ravenOptions = {
    ignoreUrls: [/graph\.facebook\.com/],
    ignoreErrors: ['Failed to register a ServiceWorker']
};
Raven.config('https://f6ed99c58c5a44e6a693251cabe6ab8d@sentry.io/1295173', ravenOptions).install();

//initialize pinterest tag
ReactPinterestTag.init('2613543587498')

//start loader on history change start
history.listen(location => store.dispatch(showLoading()));


function onRouteChangeFinish() {
    //track react pageview
    ReactGA.set({ page: window.location.pathname });
    ReactGA.pageview(window.location.pathname);
    store.dispatch(hideLoading());
    ReactPinterestTag.pageView()
}


ReactDOM.render( <Provider store={store}>
    <LanguageProvider >
        <Router
            history={history}
            routes={rootRoute}
            onUpdate={onRouteChangeFinish}
            render={
                // Scroll to top when going to a new page, imitating default browser
                // behaviour
                applyRouterMiddleware(
                    useScroll((prevRouterProps, { location }) => {
                        console.log(prevRouterProps);
                        console.log(location);
                        return (
                            prevRouterProps &&
                            location.pathname.split('/')[1] !==
                            prevRouterProps.location.pathname.split('/')[1]
                        );
                    })
                )
            }
        />
    </LanguageProvider>
</Provider>, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
